import React, { useState } from "react";
import { Button} from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {ORDER_API} from '../../apiConfig'
import { useNavigate, useLocation } from "react-router-dom";

export default function Bd({ productDetails, selectedRfq }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [bulkDecision, setBulkDecision] = useState("");
    const [showBulkModal, setShowBulkModal] = useState(false);
    const [bulkComment, setBulkComment] = useState("");
    const [showProductModal, setShowProductModal] = useState(false);
    const [viewProductDetails, setViewProductDetails] = useState("")
    const [header, setHeader] = useState("")
    const [selectedIds, setSelectedIds] = useState([]);

    const handleOdIdClick = (od_id) => {
        navigate("/cable/outbound-process/outbound-delivery", {
            state: {
                openOdId: od_id,
                returnTo: location.pathname
            }
        });
    };

    const handleSoIdClick = (so_id) => {
        navigate("/cable/sales/sales-order", {
            state: {
                openSoId: so_id,
                returnTo: location.pathname
            }
        });
    };

    const handleSelectAll = (checked) => {
        if (checked) {
            // Only select items that are NOT 'Approved' or 'Rejected' (Pending items)
            const selectableIds = productDetails
                .filter(p => p.bi_action !== 'Approved' && p.bi_action !== 'Rejected')
                .map(p => p.id); // Use unique ID

            setSelectedIds(selectableIds);
        } else {
            setSelectedIds([]);
        }
    };

    const handleSelectProduct = (e, id) => {
        if (e.target.checked) {
            setSelectedIds((prev) => [...prev, id]);
        } else {
            setSelectedIds((prev) => prev.filter((item) => item !== id));
        }
    };

    const submitDecision = async (decisionType) => {
        if (selectedIds.length === 0) {
            toast.warning("Please select at least one product!", { position: "top-center" });
            return;
        }
        const partsToSubmit = productDetails
            .filter((part) => selectedIds.includes(part.id))
            .map((part) => ({
                id: part.id,
                bi_action: decisionType,
                bi_comment: bulkComment,
                bi_action_by: localStorage.getItem("userName") || "Unknown System User",
            }));
        if (partsToSubmit.length === 0) {
            console.error("Filter resulted in empty array. Check selectedProducts state.");
            return;
        }

        try {
            const response = await fetch(`${ORDER_API}/billing/${selectedRfq.bi_id}/update-product-action`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ parts: partsToSubmit }),
            });

            if (response.ok) {
                toast.success(`${decisionType} submitted successfully`, {
                    position: "top-center",
                    autoClose: 3000
                });
                setShowBulkModal(false);
                window.location.reload();
            } else {
                const errorData = await response.json();
                toast.error(errorData.message || "Failed to submit decision", { position: "top-center" });
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast.error("Error submitting decision", { position: "top-center" });
        }
    };

    const handleViewProductDetails = async (id) => {
        try {
            const response = await fetch(`${ORDER_API}/billing/item/${id}`);

            if (response.ok) {
                const data = await response.json();
                setViewProductDetails(data);
                setShowProductModal(true);
            } else {
                alert("Failed to fetch product details.");
            }
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div>
            <hr />
            <div className="d-flex gap-2 mb-3" style={{ justifyContent: 'flex-end' }}>
                <Button
                    variant="dark"
                    disabled={selectedIds.length === 0}
                    onClick={() => {
                        setBulkDecision("Approved");
                        setHeader("Approve");
                        setBulkComment("");
                        setShowBulkModal(true);
                    }}
                >
                    Approve
                </Button>
                <Button
                    variant="dark"
                    disabled={selectedIds.length === 0}
                    onClick={() => {
                        setBulkDecision("Rejected");
                        setHeader("Reject")
                        setBulkComment("");
                        setShowBulkModal(true);
                    }}
                >
                    Reject
                </Button>
                {/* <Button
                    variant="dark"
                    disabled={selectedIds.length === 0}
                    onClick={() => {
                        setBulkDecision("Queried");
                        setHeader("Query")
                        setBulkComment("");
                        setShowBulkModal(true);
                    }}
                >
                    Query
                </Button> */}
            </div>

            <div style={{
                ...styles.tableContainer,
                overflowX: 'auto',
                marginTop: '1rem',
                borderRadius: '8px',
                border: '1px solid #e2e8f0'
            }}>
                <table className="table table-hover mb-0" style={{
                    ...styles.erpTable,
                    width: 'max-content',
                    minWidth: '100%',
                    borderCollapse: 'collapse'
                }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f8fafc' }}>

                            <th style={{ ...styles.erpTh, textAlign: "center", width: '40px', minWidth: '40px' }}>
                                <input
                                    type="checkbox"
                                    // Logic: Checked only if there are pending items AND all pending items are selected
                                    checked={
                                        productDetails.length > 0 &&
                                        productDetails.some(p => p.bi_action !== 'Approved' && p.bi_action !== 'Rejected') &&
                                        productDetails
                                            .filter(p => p.bi_action !== 'Approved' && p.bi_action !== 'Rejected')
                                            .every(p => selectedIds.includes(p.id))
                                    }
                                    onChange={(e) => handleSelectAll(e.target.checked)}
                                />
                            </th>
                            <th style={{ ...styles.erpTh, textAlign: "center", whiteSpace: 'nowrap', minWidth: '60px' }}>Item</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '180px' }}>OD ID</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '180px' }}>SO ID</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '150px' }}>Product Code</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '250px' }}>Description</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '80px' }}>UOM</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '120px' }}>Unit Price</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '100px' }}>Quantity</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '100px' }}>Del. Qty</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '120px' }}>Req. Date</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '100px' }}>Discount</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '120px' }}>Status</th>
                            <th style={{ ...styles.erpTh, whiteSpace: 'nowrap', minWidth: '80px' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {productDetails.length === 0 ? (
                            <tr>
                                <td colSpan={14} style={{ ...styles.erpTd, textAlign: "center", padding: '20px' }}>
                                    No Products Available
                                </td>
                            </tr>
                        ) : (
                            productDetails.map((part, idx) => {
                                const isDisabled = part.bi_action === 'Approved' || part.bi_action === 'Rejected';

                                return (
                                    <tr key={idx} style={{
                                        borderBottom: '1px solid #f1f5f9',
                                        backgroundColor: isDisabled ? '#fcfcfc' : 'transparent',
                                        opacity: isDisabled ? 0.7 : 1
                                    }}>
                                        <td style={{ ...styles.erpTd, textAlign: "center" }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedIds.includes(part.id)}
                                                onChange={(e) => handleSelectProduct(e, part.id)}
                                                disabled={isDisabled}
                                                style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                            />
                                        </td>

                                        <td style={{ ...styles.erpTd, textAlign: "center" }}>{idx + 1}</td>


                                        <td style={styles.erpTd}>{part.od_id ? (
                                            <span
                                                onClick={() => handleOdIdClick(part.od_id)}
                                                style={{ color: "#1976d2", cursor: "pointer", fontWeight: 600, textDecoration: "underline", textUnderlineOffset: "2px" }}
                                            >
                                                {part.od_id}
                                            </span>
                                        ) : "-"}</td>
                                        <td style={styles.erpTd}>{part.so_id ? (
                                            <span
                                                onClick={() => handleSoIdClick(part.so_id)}
                                                style={{ color: "#1976d2", cursor: "pointer", fontWeight: 600, textDecoration: "underline", textUnderlineOffset: "2px" }}
                                            >
                                                {part.so_id}
                                            </span>
                                        ) : "-"}</td>
                                        <td style={styles.erpTd}>{part.product_code}</td>
                                        <td style={styles.erpTd}>{part.description}</td>
                                        <td style={styles.erpTd}>{part.uom}</td>
                                        <td style={styles.erpTd}>{part.unit_price}</td>
                                        <td style={styles.erpTd}>{part.quantity}</td>
                                        <td style={styles.erpTd}>{part.delivery_qty}</td>
                                        <td style={styles.erpTd}>
                                            {/* {part.requirement_date
                                                ? new Date(part.requirement_date).toLocaleDateString("en-GB")
                                                : "N/A"} */}
                                            {part.requirement_date ? (() => {
                                                const d = new Date(part.requirement_date);
                                                const day = String(d.getDate()).padStart(2, '0');
                                                const month = String(d.getMonth() + 1).padStart(2, '0');
                                                const year = d.getFullYear();
                                                return `${day}/${month}/${year}`;
                                            })() : "N/A"}
                                        </td>
                                        <td style={styles.erpTd}>{part.discount}</td>
                                        <td style={styles.erpTd}>{part.bi_action}</td>
                                        <td style={{ ...styles.erpTd, textAlign: 'center' }}>
                                            <button
                                                className="btn btn-sm"
                                                style={{
                                                    fontSize: '11px',
                                                    padding: '2px 10px',
                                                    border: '1px solid #cbd5e1',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#fff'
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleViewProductDetails(part.id);
                                                }}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {showBulkModal && (
                <div style={styles.modalBackdrop}>
                    <div style={{ ...styles.modal, maxWidth: "600px", width: "100%" }}>
                        <div style={styles.modalHeader}>
                            <div style={{ fontWeight: 600 }}>{`Submit ${header}`}</div>
                            <button style={styles.iconBtn} onClick={() => setShowBulkModal(false)}>✕</button>
                        </div>

                        <div style={styles.modalBody}>
                            <textarea
                                value={bulkComment}
                                onChange={(e) => setBulkComment(e.target.value)}
                                placeholder="Enter your comment here"
                                rows="4"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    border: "1px solid #ccc",
                                    resize: "none",
                                }}
                            />
                        </div>

                        <div style={styles.modalFooter}>
                            <button className="btn btn-outline-secondary" onClick={() => setShowBulkModal(false)}>Cancel</button>
                            <button className="btn btn-dark" onClick={() => submitDecision(bulkDecision)}>Submit</button>
                        </div>
                    </div>
                </div>
            )}

            {showProductModal && viewProductDetails && (
                <div style={styles.modalBackdrop}>
                    <div
                        style={{
                            ...styles.modal,
                            maxWidth: "950px",
                            width: "95%",
                            maxHeight: "85vh",
                            padding: "14px",
                            fontSize: "13px"
                        }}
                    >


                        {/* ================= BODY ================= */}
                        <div style={{ padding: "12px" }}>

                            {/* ===== TOP ROW (LIKE PIC) ===== */}
                            <table className="table table-bordered table-sm mb-3">
                                <thead style={{ background: "#f8fafc", fontWeight: 600 }}>
                                    <tr>
                                        <th>Product Code</th>
                                        <th>HSN Code</th>
                                        <th>Quantity</th>
                                        <th>Unit Price</th>
                                        <th>Discount (%)</th>
                                        <th>Total Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{viewProductDetails.product_code}</td>
                                        <td>{viewProductDetails.hsn_code}</td>
                                        <td>{viewProductDetails.delivery_qty}</td>
                                        <td>₹ {viewProductDetails.unit_price}</td>
                                        <td>{viewProductDetails.discount}</td>
                                        <td style={{ fontWeight: 600 }}>
                                            ₹ {viewProductDetails.totalPrice}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* ===== NET PRICE LINE ===== */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "8px 10px",
                                    borderTop: "1px solid #999",
                                    borderBottom: "1px solid #999",
                                    marginBottom: "10px",
                                    fontWeight: 600
                                }}
                            >
                                <span>Net Price :</span>
                                <span>₹ {viewProductDetails.netPrice}</span>
                            </div>

                            {/* ===== GST BREAKUP ===== */}
                            <table
                                className="table table-sm"
                                style={{ width: "50%", marginLeft: "auto" }}
                            >
                                <tbody>
                                    <tr>
                                        <td>CGST @ {viewProductDetails.cgst}%</td>
                                        <td style={{ textAlign: "right" }}>
                                            ₹ {viewProductDetails.cgstAmount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>SGST @ {viewProductDetails.sgst}%</td>
                                        <td style={{ textAlign: "right" }}>
                                            ₹ {viewProductDetails.sgstAmount}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>IGST @ {viewProductDetails.igst}%</td>
                                        <td style={{ textAlign: "right" }}>
                                            ₹ {viewProductDetails.igstAmount}
                                        </td>
                                    </tr>
                                    <tr style={{ borderTop: "1px solid #000", fontWeight: 600 }}>
                                        <td>Total GST</td>
                                        <td style={{ textAlign: "right" }}>
                                            ₹ {viewProductDetails.totalGST}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* ===== GRAND TOTAL ===== */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "12px",
                                    marginTop: "8px",
                                    background: "#f1f5f9",
                                    fontWeight: 700,
                                    fontSize: "15px",
                                    borderRadius: "4px"
                                }}
                            >
                                <span>Grand Total :</span>
                                <span>₹ {viewProductDetails.finalPriceWithGST}</span>
                            </div>
                        </div>

                        {/* ================= FOOTER ================= */}
                        <div style={{ ...styles.modalFooter, padding: "10px 14px" }}>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => setShowProductModal(false)}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer position="top-center" autoClose={3000} />
        </div>
    );
}


const styles = {
    compactLabel: { fontSize: "12px", fontWeight: 600, marginBottom: "2px", color: '#334155' },
    compactInput: { fontSize: "13px", height: "34px", padding: "4px 8px" },
    compactTabBtn: { fontSize: "13px", padding: "4px 10px" },
    tableContainer: { background: "#ffffff", borderRadius: 8, padding: 12, boxShadow: "0 1px 4px rgba(0,0,0,0.08)" },
    erpTable: { width: "100%", tableLayout: "fixed", borderCollapse: "collapse" },
    erpTh: { background: "#f8fafc", fontSize: 12, fontWeight: 600, padding: "10px 12px", borderBottom: "1px solid #e5e7eb", color: "#1e293b", whiteSpace: "nowrap" },
    erpTd: { fontSize: 13, padding: "10px 12px", borderBottom: "1px solid #f1f5f9", color: "#334155", verticalAlign: "middle" },
    filterCard: { background: '#ffffff', borderRadius: 8, padding: 20, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginBottom: 18 },
    filterLabel: { fontSize: 12, fontWeight: 600, marginBottom: 6, color: '#334155' },
    filterSelect: { height: 36, fontSize: 13 },
    pageTitleBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
    pageTitle: { fontSize: 20, fontWeight: 700, color: '#1e293b' },
    pageSubtitle: { fontSize: 12, color: '#64748b' },
    primaryBtn: { paddingLeft: 14, paddingRight: 14 },
    modalBackdrop: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '20px' },
    modal: { background: '#fff', borderRadius: '8px', width: '90%', maxWidth: '1200px', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
    modalHeader: { padding: '15px 20px', borderBottom: '1px solid #ddd', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    iconBtn: { background: 'transparent', border: 'none', fontSize: '16px', cursor: 'pointer' },
    modalBody: { padding: '20px', overflowY: 'auto', flex: 1 },
    modalFooter: { padding: '15px 20px', borderTop: '1px solid #ddd', display: 'flex', justifyContent: 'flex-end', gap: '10px' },
    tabs: { display: 'flex', gap: 8, margin: '14px 0' },
};